// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_rt--b","headItem":"index_headItem_xsFku","headIcon":"index_headIcon_ZzRwT","table":"index_table_2kmKj","avatar":"index_avatar_3-Hfu"};